import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetMyUpcomingReservationsResponseDto } from "../generated/generatedTypes";

const fetchMyReservations = async (
  time: "upcoming" | "past" | "latest" = "upcoming"
): Promise<GetMyUpcomingReservationsResponseDto[]> => {
  let url = "api/reservation/me";
  switch (time) {
    case "upcoming":
      url = "api/reservation/me";
      break;
    case "past":
      url = "api/reservation/me?time=past";
      break;
    case "latest":
      url = "api/reservation/me?time=latest";
      break;
  }

  const response = await apiFetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${time} reservations from ${url}`);
  }
  const data = await response.json();
  return data as GetMyUpcomingReservationsResponseDto[];
};

export function useGetMyUpcomingReservations() {
  return useQuery<GetMyUpcomingReservationsResponseDto[], Error>({
    queryKey: ["myUpcomingReservations"],
    queryFn: () => fetchMyReservations("upcoming"),
  });
}

export function useGetMyPastReservations({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<GetMyUpcomingReservationsResponseDto[], Error>({
    queryKey: ["myPastReservations"],
    queryFn: () => fetchMyReservations("past"),
    enabled,
  });
}

export function useGetMyLatestReservation({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<GetMyUpcomingReservationsResponseDto | null, Error>({
    queryKey: ["myLatestReservation"],
    queryFn: async () => {
      const result = await fetchMyReservations("latest");
      return result.length > 0 ? result[0] : null;
    },
    enabled,
  });
}
